import { Controller } from 'stimulus';
import $ from "jquery";

export default class extends Controller {
  static targets = [
    'tierRate',
    'orderCount',
    'orderAmount',
    'collection',
    'kind',
    'tierKind',
    'criteria',
    'helpTop'
  ];

  connect() {
    $('input[name="commission_rate[kind]"]').on("change", () => {
      this.reshuffleScreen();
    });

    $('input[name="commission_rate[tier_kind]"]').on("change", () => {
      this.reshuffleScreen();
    });

    $('input[name="commission_rate[criteria]"]').on("change", () => {
      this.reshuffleScreen();
    });

    $('input[name="commission_rate[commission_rate]"]').on("change", () => {
      this.writeBottomHelp();
    });

    $('input[name="commission_rate[threshold_count]"]').on("change", () => {
      this.writeBottomHelp();
    });

    $('input[name="commission_rate[threshold_amount]"]').on("change", () => {
      this.writeBottomHelp();
    });

    $('#create-commission-rate').on('submit', (e) => {
      e.preventDefault();
      e.stopPropagation();

      this.submit();

      return false;
    });

    this.reshuffleScreen();
  }

  enableTiers() {
    this.tierRateTarget.style.backgroundColor = 'lightgreen'
    this.tierRateTarget.style.backgroundColor = 'lightgreen'
  }

  reshuffleScreen() {
    const kind = $('input[name="commission_rate[kind]"]:checked').val();
    const tier_kind = $('input[name="commission_rate[tier_kind]"]:checked').val();
    const criteria = $('input[name="commission_rate[criteria]"]:checked').val();

    if (kind == 'collection_base') {
      $('#tier-rate').hide();
      $('#collection').show();

      $('#help-top').text('COLLECTION BASE RATES WILL OVERRIDE THE DEFAULT RATE, BUT ONLY FOR ITEMS IN THE CHOSEN COLLECTION.')
    } else {
      $('#tier-rate').show();

      if (tier_kind == 'global') {
        $('#collection').hide();
        $('#help-top').text('GLOBAL TIER RATES WILL OVERRIDE THE DEFAULT RATE ONCE THE AFFILIATE HAS REACHED THE THRESHOLD (EITHER TOTAL AMOUNT REFERRED, OR NUMBER OF ORDERS REFERRED).');
      } else {
        $('#collection').show();
        $('#help-top').text('COLLECTION TIER RATES WILL OVERRIDE THE GLOBAL BASE RATE, ANY COLLECTION-SPECIFIC BASE RATE, AND GLOBAL TIER RATES, BUT ONLY FOR ITEMS INCLUDED IN THE COLLECTION.');
      }

      if (criteria == 'order_count') {
        $('#order-count').show();
        $('#order-amount').hide();
      } else {
        $('#order-count').hide();
        $('#order-amount').show();
      }
    }

    this.writeBottomHelp();
  }

  writeBottomHelp() {
    const kind = $('input[name="commission_rate[kind]"]:checked').val();
    const tier_kind = $('input[name="commission_rate[tier_kind]"]:checked').val();
    const criteria = $('input[name="commission_rate[criteria]"]:checked').val();
    const rate = parseFloat($('input[name="commission_rate[commission_rate]"]').val() || "0").toFixed(2);
    const threshold_amount = parseFloat($('input[name="commission_rate[threshold_amount]"]').val() || "0").toFixed(2);
    const threshold_count = parseInt($('input[name="commission_rate[threshold_count]"]').val() || "0", 10);

    const bottomHelp = $('#help-bottom');
    const currency = bottomHelp.data("currency")

    if (kind == 'collection_base') {
      bottomHelp.empty();
    } else {
      if (tier_kind == 'global') {
        if (criteria == 'order_count') {
          bottomHelp.text(
            `Your affiliate will receive ${rate}% on all orders after referring ${threshold_count} orders.`
          )
        } else {
          bottomHelp.text(
            `Your affiliate will receive ${rate}% on any amount beyond ${currency}${threshold_amount}`
          )
        }
      } else {
        if (criteria == 'order_count') {
          bottomHelp.text(
            `Your affiliate will receive ${rate}% on all subsequent items in that collection after referring ${threshold_count} items in this collection.`
          )
        } else {
          bottomHelp.text(
            `Your affiliate will receive ${rate}% on any amount beyond ${currency}${threshold_amount} from this collection after referring ${currency}${threshold_amount} worth of items from this collection.`
          )
        }
      }
    }
  }

  submit() {
    const form = $('#create-commission-rate');
    const url = form.attr('action');
    const data = this.getFormData(form);

    $.post(url, data).done((response) => {
      window.location = response.redirect;
    }).fail((jqXHR, textStatus, error) => {
      const errors = JSON.parse(jqXHR.responseText);
      // console.log(errors)
   });
  }

  getFormData($form) {
    var unindexed_array = $form.serializeArray();
    var indexed_array = {};

    $.map(unindexed_array, function(n, i){
        indexed_array[n['name']] = n['value'];
    });

    return indexed_array;
  }
}
